import React, { FC, useState } from 'react'
import { TextBody, get } from '@ally/metronome-ui'
import styled from 'styled-components'
import { TransactionHistoryTableModel, CheckDetails } from '../../../../types'
import { TransactionDetailModal } from './TransactionDetailModal'
import { FormattedAmountString } from '../../FormattedAmountString'
import { FlexedButton } from './TransactionHistoryTable'

const LeftColumn = styled('div')`
  background: ${get.colors('white')};
  color: ${get.colors('slate-5')};
  width: 75%;
`
const RightColumn = styled('div')`
  color: ${get.colors('slate-5')};
  justify-content: right;
  justify-items: right;
  align-items: center;
  display: flex;
`

const Card = styled('div')`
  background: ${get.colors('white')};
  color: ${get.colors('slate-5')};
  display: flex;
  justify-content: space-between;
`
const SingleColumnCard = styled('div')`
  background: ${get.colors('white')};
  color: ${get.colors('slate-5')};
  display: grid;
`

export const TransactionHistoryMobileCard: FC<{
  data: TransactionHistoryTableModel | JSX.Element
  custom?: boolean
  printCheckCallback: (data: CheckDetails) => void
}> = ({ data, custom, printCheckCallback }) => {
  const [showModal, setShowModal] = useState(false)

  if (custom) {
    return (
      <SingleColumnCard data-testid="singleColumnCard">{data}</SingleColumnCard>
    )
  }
  const { date, amount, description } = data as TransactionHistoryTableModel

  return (
    <Card tabIndex={-1}>
      <LeftColumn>
        <TextBody size="sm" tag="p">
          {date}
        </TextBody>
        <FlexedButton
          variant="link"
          text={description}
          onClick={(): void => setShowModal(true)}
          data-testid="transaction-history-desc"
        />
        <TransactionDetailModal
          data={data}
          printCheckCallback={printCheckCallback}
          showModal={showModal}
          closeModal={
            // istanbul ignore next // we have a test for this already
            (): void => setShowModal(false)
          }
        />
      </LeftColumn>
      <RightColumn>
        <FormattedAmountString value={amount as number} />
      </RightColumn>
    </Card>
  )
}
